<div class="sign-in-shell">
  <div class="sign-in-shell-row" fxLayout="row" fxLayout.lt-md="column">
    <div class="sign-in-shell-col" fxFlex="50%" fxFlex.lt-md="100%"></div>
    <div class="sign-in-shell-col" fxFlex="50%" fxFlex.lt-md="100%">
      <h1 class="sign-in-shell-title">BRIO connector</h1>

      <ng-container *ngIf="!(authService.signedIn | async)">
        <app-sign-in-form></app-sign-in-form>
      </ng-container>

<!--Note: We do not handle the initial complete password flow in this app-->

<!--      <ng-container *ngIf="!(authService.signedIn | async) && !(authService.newPasswordRequired | async)">-->
<!--        <app-sign-in-form></app-sign-in-form>-->
<!--      </ng-container>-->
<!--      <ng-container *ngIf="authService.newPasswordRequired | async">-->
<!--        <app-sign-in-change-password [user]="authService.newPasswordRequired | async"></app-sign-in-change-password>-->
<!--      </ng-container>-->

      <ng-container *ngIf="authService.signedIn | async">
        <app-sign-in-select-profile></app-sign-in-select-profile>
      </ng-container>
    </div>
  </div>
</div>
